import React from 'react';
import { Icon, IconColorStyle, IconSize } from '@adaptis/flow-components';
import { IFeatureLabelProps } from './FeatureLabel.types';

import './FeatureLabel.scss';

export default function FeatureLabel(props: IFeatureLabelProps) {
  return (
    <div data-testid='FeatureLabel' className='flc_feature-label'>
      <Icon
        className='me-2'
        src={props.image}
        colorStyle={props.iconColorStyle as IconColorStyle}
        size={IconSize.ExtraSmall}
      />
      <span className={props.isBold ? 'bold' : ''}>{props.label}</span>
    </div>
  );
}
